export const PAGE_TITLE = 'Services';
export const PAGE_SINGLE_TITLE = 'Service';
export const LINK_URL = 'services';

export const inputFields = {
  serviceName: {
    type: 'string',
    required: true,
    title: 'Service Name',
    inputType: 'text',
    placeholder: 'Enter service name (e.g., Oil Change, Tire Rotation)',
  },
  serviceDescription: {
    type: 'string',
    required: true,
    title: 'Service Description',
    inputType: 'textarea',
    placeholder: 'Enter detailed service description',
    rows: 4,
  },
  serviceShortName: {
    type: 'string',
    required: true,
    title: 'Service Short Name',
    inputType: 'text',
    placeholder: 'Enter short name (e.g., OIL_CHANGE, TIRE_ROT)',
  },
  serviceCategory: {
    type: 'select',
    required: true,
    title: 'Service Category',
    inputType: 'select',
    options: [
      'MAINTENANCE',
      'REPAIR',
      'INSTALLATION',
      'INSPECTION',
      'CONSULTATION',
      'OTHER',
    ],
  },
  gstTaxRate: {
    type: 'select',
    required: true,
    title: 'GST Tax Rate (%)',
    inputType: 'select',
    options: ['18', '28', '12', '5', '0'],
  },
  gstType: {
    type: 'select',
    required: true,
    title: 'GST Type',
    inputType: 'select',
    options: ['CGST_SGST', 'IGST', 'EXEMPT', 'NIL_RATED'],
  },
  unit: {
    type: 'select',
    required: true,
    title: 'Unit',
    inputType: 'select',
    options: ['SERVICE', 'HOUR', 'JOB', 'PIECE', 'KM', 'LITER'],
  },
  hsnCode: {
    type: 'string',
    required: true,
    title: 'HSN Code',
    inputType: 'text',
    placeholder: 'Enter HSN code',
  },
  hsnSubCode: {
    type: 'string',
    required: false,
    title: 'HSN Sub Code',
    inputType: 'text',
    placeholder: 'Enter HSN sub code (optional)',
  },
  warranty: {
    type: 'string',
    required: false,
    title: 'Warranty Information',
    inputType: 'textarea',
    placeholder: 'Enter warranty terms and conditions',
    rows: 3,
  },
  serviceImage: {
    type: 'file',
    required: false,
    title: 'Service Image',
    inputType: 'file',
    accept: 'image/*',
  },
  estimatedDuration: {
    type: 'string',
    required: false,
    title: 'Estimated Duration (minutes)',
    inputType: 'number',
    placeholder: 'Enter estimated duration in minutes',
    min: 1,
    max: 10080,
  },
  complexityLevel: {
    type: 'select',
    required: false,
    title: 'Complexity Level',
    inputType: 'select',
    options: ['BASIC', 'INTERMEDIATE', 'ADVANCED', 'EXPERT'],
  },
  prerequisites: {
    type: 'string',
    required: false,
    title: 'Prerequisites',
    inputType: 'textarea',
    placeholder: 'Enter any prerequisites for this service',
    rows: 2,
  },
  requiredEquipment: {
    type: 'string',
    required: false,
    title: 'Required Equipment',
    inputType: 'textarea',
    placeholder: 'List required tools/equipment (one per line)',
    rows: 3,
  },
  productType: {
    type: 'related',
    required: true,
    title: 'Product Type',
    inputType: 'select',
    searchItem: 'producttype',
  },
  published_status: {
    type: 'select',
    required: true,
    title: 'Status',
    inputType: 'select',
    options: ['DRAFT', 'PUBLISHED', 'INACTIVE'],
  },
};

export const initialValues = {
  serviceName: '',
  serviceDescription: '',
  serviceShortName: '',
  serviceCategory: '',
  gstTaxRate: '',
  gstType: '',
  unit: '',
  hsnCode: '', // Default services HSN code
  hsnSubCode: '',
  warranty: '',
  serviceImage: '',
  estimatedDuration: '',
  complexityLevel: '',
  prerequisites: '',
  requiredEquipment: '',
  productType: '',
  published_status: 'DRAFT',
};

export const view_all_table = [
  { name: 'Service Name', value: 'serviceName' },
  { name: 'Short Name', value: 'serviceShortName' },
  { name: 'Category', value: 'serviceCategory' },
  { name: 'Duration (min)', value: 'estimatedDuration' },
  { name: 'Complexity', value: 'complexityLevel' },
  { name: 'GST Rate', value: 'gstTaxRate' },
  { name: 'Unit', value: 'unit' },
  { name: 'Status', value: 'published_status' },
];

export const SIDEBAR_OPTIONS = [
  {
    id: 'serviceName',
    field: 'serviceName',
    label: 'Service Name',
    type: 'string',
    search_type: 'like',
    inputType: 'text',
    condition: '',
  },
  {
    id: 'serviceCategory',
    field: 'serviceCategory',
    label: 'Category',
    type: 'select',
    search_type: 'exact',
    inputType: 'select',
    condition: '',
    options: [
      'MAINTENANCE',
      'REPAIR',
      'INSTALLATION',
      'INSPECTION',
      'CONSULTATION',
      'OTHER',
    ],
  },
  {
    id: 'complexityLevel',
    field: 'complexityLevel',
    label: 'Complexity',
    type: 'select',
    search_type: 'exact',
    inputType: 'select',
    condition: '',
    options: ['BASIC', 'INTERMEDIATE', 'ADVANCED', 'EXPERT'],
  },
  {
    id: 'gstTaxRate',
    field: 'gstTaxRate',
    label: 'GST Rate',
    type: 'select',
    search_type: 'exact',
    inputType: 'select',
    condition: '',
    options: ['0', '5', '12', '18', '28'],
  },
  {
    id: 'published_status',
    field: 'published_status',
    label: 'Status',
    type: 'select',
    search_type: 'exact',
    inputType: 'select',
    condition: '',
    options: ['DRAFT', 'PUBLISHED', 'INACTIVE'],
  },
];
